import { AxiosError } from 'axios';
import { useState } from 'react';

import { DispatchVolumeChartData } from '../../../models/dashboard/dashboard/dispatcher-volume-data';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { dispatchVolumeDataActions } from '../../../redux/slices/dispatchVolumeDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDispatcherVolumeChart = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onDispatcherVolumeChartError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong while retrieving dispatcher volume chart data');
    };

    const onDispatcherVolumeChartSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<DispatchVolumeChartData[]>) => {
        dispatch(dispatchVolumeDataActions.setDispatchVolumeData(data));
    };

    const dispatcherVolumeChartData = async () => {
        const url: HttpConfig = {
            url: `ba/v1/dashboard/dispatch-volume`,
            method: 'get',
        };

        return request(url, onDispatcherVolumeChartSuccess, setLoading, onDispatcherVolumeChartError);
    };

    return { dispatcherVolumeChartData, loading };
};

export default useDispatcherVolumeChart;


